import {
  select_styles_default
} from "./chunk.ZUM2U5L3.js";
import {
  FormControl
} from "./chunk.HH2JJZ37.js";
import {
  menuItemSelectors
} from "./chunk.QHZ3R2SE.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  getTextContent
} from "./chunk.CLKP6Z3C.js";
import {
  getTag,
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/select/select.ts
import { t as t2 } from "i18next";
var averageMenuItemHeight = 42;
var FadvSelect = class extends FormControl {
  constructor() {
    super(...arguments);
    this.isOpen = false;
    this.displayLabel = "";
    this.displayTags = [];
    this.isNative = false;
    this.optionCount = 0;
    this.multiple = false;
    this.maxTagsVisible = 3;
    this.disabled = false;
    this.hoist = false;
    this.required = false;
    this.clearable = false;
    this.value = "";
    this.scrollable = false;
    this.native = false;
    this.breakpoint = "sm";
  }
  connectedCallback() {
    super.connectedCallback();
    this.handleSlotChange = this.handleSlotChange.bind(this);
    this.resizeObserver = new ResizeObserver(() => this.handleResize());
    this.updateComplete.then(() => {
      var _a;
      this.resizeObserver.observe(this);
      (_a = this.shadowRoot) == null ? void 0 : _a.addEventListener("slotchange", this.handleSlotChange);
      this.syncItemsFromValue();
    });
  }
  firstUpdated() {
    this.handleResize();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.resizeObserver.unobserve(this);
  }
  getItemLabel(item) {
    var _a;
    const slot = (_a = item.shadowRoot) == null ? void 0 : _a.querySelector("slot:not([name])");
    return getTextContent(slot);
  }
  getItems() {
    return [...this.children].filter((c) => menuItemSelectors.includes(getTag(c)));
  }
  getValueAsArray() {
    if (this.value === "") {
      return [];
    }
    return Array.isArray(this.value) ? this.value : [this.value];
  }
  handleBlur() {
    if (!this.isOpen) {
      super.handleBlur();
    }
    if (this.isNative) {
      this.base.classList.remove("select--open");
    }
  }
  handleClearClick(event) {
    event.stopPropagation();
    this.value = this.multiple ? [] : "";
    emit(this, "sl-clear");
    if (this.select) {
      this.select.value = "";
      if (this.multiple) {
        [...this.select.options].forEach((o2) => o2.selected = false);
      }
    }
    this.syncItemsFromValue();
  }
  handleDisabledChange() {
    if (this.disabled && this.isOpen) {
      this.dropdown.hide();
    }
    if (this.input) {
      this.input.disabled = this.disabled;
    }
  }
  handleFocus() {
    if (!this.hasFocus) {
      super.handleFocus();
      if (this.isNative) {
        this.base.classList.add("select--open");
      }
    }
  }
  handleKeyDown(event) {
    const target = event.target;
    const items = this.getItems();
    const firstItem = items[0];
    const lastItem = items[items.length - 1];
    if (hasTag(target, "fadv-tag")) {
      return;
    }
    if (event.key === "Tab") {
      if (this.isOpen && !this.hasSlotController.test("search") && !this.menu.shouldRenderSearch) {
        this.dropdown.hide();
      }
      return;
    }
    if (["ArrowDown", "ArrowUp"].includes(event.key)) {
      event.preventDefault();
      if (!this.isOpen) {
        this.dropdown.show();
      }
      if (event.key === "ArrowDown" && firstItem) {
        this.menu.setCurrentItem(firstItem);
        firstItem.focus();
        return;
      }
      if (event.key === "ArrowUp" && lastItem) {
        this.menu.setCurrentItem(lastItem);
        lastItem.focus();
        return;
      }
    }
    if (event.ctrlKey || event.metaKey) {
      return;
    }
    if (!this.isOpen && event.key.length === 1) {
      event.stopPropagation();
      event.preventDefault();
      this.dropdown.show();
      this.menu.typeToSelect(event);
    }
  }
  handleLabelClick() {
    var _a;
    if (this.isNative) {
      this.select.focus();
    } else {
      const box = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(".select__control");
      box.focus();
    }
  }
  handleMenuSelect(event) {
    var _a;
    const item = event.detail.item;
    if (this.multiple) {
      this.value = ((_a = this.value) == null ? void 0 : _a.includes(item.value)) ? this.value.filter((v) => v !== item.value) : [...this.value, item.value];
    } else {
      this.value = item.value;
    }
    this.syncItemsFromValue();
  }
  handleMenuShow() {
    this.handleResize();
    this.isOpen = true;
  }
  handleMenuHide() {
    var _a;
    this.isOpen = false;
    (_a = this.control) == null ? void 0 : _a.focus();
  }
  handleChange() {
    if (this.multiple) {
      this.value = [...this.select.options].filter((o2) => o2.selected).map((o2) => o2.value);
    } else {
      if (this.select.value === "") {
        const currentOption = [...this.select.options].find((o2) => o2.value === this.value);
        if (currentOption) {
          currentOption.selected = true;
          return;
        }
      }
      this.value = this.select.value;
    }
  }
  handleMultipleChange() {
    const value = this.getValueAsArray();
    this.value = this.multiple ? value : value[0] || "";
    this.syncItemsFromValue();
  }
  async handleMenuSlotChange() {
    const items = this.getItems();
    const values = [];
    items.forEach((item) => {
      if (values.includes(item.value)) {
        console.error(`Duplicate value found in <fadv-select> menu item: '${item.value}'`, item);
      }
      values.push(item.value);
    });
    await Promise.all(items.map((item) => item.render)).then(() => this.syncItemsFromValue());
  }
  handleNativeSlotChanged() {
    this.optionCount = this.children.length;
  }
  handleTagInteraction(event) {
    const path = event.composedPath();
    const clearButton = path.find((el) => {
      if (el instanceof HTMLElement) {
        return el.classList.contains("tag__remove");
      }
      return false;
    });
    if (clearButton) {
      event.stopPropagation();
    }
  }
  async handleValueChange() {
    this.syncItemsFromValue();
    await this.updateComplete;
    if (this.multiple) {
      if (this.isNative) {
        this.hasValue = !!this.value && this.select && [...this.select.options].some((o2) => o2.selected);
      } else {
        this.hasValue = !!this.value && this.value.length > 0;
      }
    } else {
      this.hasValue = !!this.value;
    }
    if (this.isNative && this.hasValue) {
      this.base.classList.remove("select--open");
    }
    emit(this, "sl-change");
  }
  handleResize() {
    var _a;
    this.isNative = this.useNative();
    if (!this.scrollable) {
      if (this.querySelectorAll("fadv-menu-item").length > 10) {
        this.scrollable = true;
      }
      const estimatedHeight = this.children.length * averageMenuItemHeight;
      if (estimatedHeight > document.body.clientHeight) {
        this.scrollable = true;
      }
    }
    if (this.menu) {
      const box = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(".select__control");
      this.menu.style.width = `${box.clientWidth}px`;
      if (this.dropdown) {
        this.dropdown.reposition();
      }
    }
  }
  syncItemsFromValue() {
    const items = this.getItems();
    const value = this.getValueAsArray();
    items.forEach((item) => item.checked = value.includes(item.value));
    if (this.multiple) {
      const checkedItems = items.filter((item) => value.includes(item.value));
      this.displayLabel = checkedItems[0] ? this.getItemLabel(checkedItems[0]) : "";
      this.displayTags = checkedItems.map((item) => {
        return $`<fadv-tag exportparts="base:tag" variant="neutral" ?pill=${this.pill} removable @click=${this.handleTagInteraction} @keydown=${this.handleTagInteraction} @sl-remove=${(event) => {
          event.stopPropagation();
          if (!this.disabled) {
            item.checked = false;
            this.syncValueFromItems();
          }
        }} >${this.getItemLabel(item)}</fadv-tag>`;
      });
      if (this.maxTagsVisible > 0 && this.displayTags.length > this.maxTagsVisible) {
        const total = this.displayTags.length;
        this.displayLabel = "";
        this.displayTags = this.displayTags.slice(0, this.maxTagsVisible);
        this.displayTags.push($`<fadv-tag exportparts="base:tag" variant="neutral"> +${total - this.maxTagsVisible}</fadv-tag>`);
      }
    } else {
      const checkedItem = items.filter((item) => item.value === value[0])[0];
      this.displayLabel = checkedItem ? this.getItemLabel(checkedItem) : "";
      this.displayTags = [];
    }
  }
  syncValueFromItems() {
    const items = this.getItems();
    const checkedItems = items.filter((item) => item.checked);
    const checkedValues = checkedItems.map((item) => item.value);
    if (this.multiple) {
      this.value = this.value.filter((val) => checkedValues.includes(val));
    } else {
      this.value = checkedValues.length > 0 ? checkedValues[0] : "";
    }
  }
  useNative() {
    return false;
  }
  focus(options) {
    this.control.focus(options);
  }
  blur() {
    this.control.blur();
  }
  renderDisplayTags() {
    if (this.displayTags.length) {
      return $`<span part="tags" class="select__tags">${this.displayTags}</span>`;
    }
    if (this.displayLabel) {
      return $`${this.displayLabel}`;
    }
    if (this.placeholder && (!this.floating || this.floating && this.hasFocus)) {
      return $`<span class="placeholder">${this.placeholder}</span>`;
    }
    return w;
  }
  renderClearable(hasSelection) {
    if (!this.clearable)
      return w;
    if (!hasSelection)
      return w;
    return $`<button part="clear-button" aria-label=${t2("components:common.clearEntry")} class="input__clear" library="system" @click=${this.handleClearClick} tabindex="-1" ><slot name="clear-icon"><fadv-icon name="circle-xmark" library="solid"></fadv-icon></slot></button>`;
  }
  renderSearch() {
    if (!this.querySelector("fadv-search"))
      return w;
    return $`<slot slot="search" name="search"></slot>`;
  }
  renderOptionElements() {
    let template = w;
    const renderOption = (item) => {
      const selected = this.multiple ? this.value.includes(item.value) : this.value && this.value === item.value;
      return $`<option ?selected=${selected} value=${item.value} ?disabled=${item.disabled || false}>${item.textContent}</option>`;
    };
    function renderGroup(label, items2) {
      return $`<optgroup label=${label}>${items2.map(renderOption)}</optgroup>`;
    }
    function renderOptionGroup(label, items2) {
      if (label && items2.length) {
        template = $`${template}${renderGroup(label, items2)}`;
      }
      if (!label && items2.length) {
        template = $`${template}${items2.map((i2) => renderOption(i2))}`;
      }
    }
    let optGroupLabel = null;
    let items = [];
    for (const child of this.children) {
      if (hasTag(child, "fadv-menu-label")) {
        renderOptionGroup(optGroupLabel, items);
        optGroupLabel = child.textContent;
        items = [];
      }
      if (hasTag(child, "fadv-menu-item")) {
        items.push(child);
      }
    }
    renderOptionGroup(optGroupLabel, items);
    if (this.multiple)
      return template;
    return $`<option></option>${template} `;
  }
  renderSelectIcon() {
    if (this.isNative && this.multiple)
      return w;
    return $`<span part="icon" class="select__icon" aria-hidden="true"><fadv-icon name="chevron-down" library="system"></fadv-icon></span>`;
  }
  renderNativeControl(hasSelection) {
    requestAnimationFrame(() => {
      var _a;
      (_a = this.base) == null ? void 0 : _a.classList.add("select--native");
    });
    return $`<span part="prefix" class="form-control__control--prefix"><slot name="prefix"></slot></span><div class=${o({
      "form-control__control-host": true,
      [`form-control__options_${this.optionCount}`]: true
    })} >${this.renderFloatingLabel()}<select part="input" id=${this.inputId} class="form-control__control" name=${l(this.name)} multiple=${l(this.multiple || void 0)} size=${l(this.size)} ?disabled=${this.disabled} ?readonly=${this.readonly} ?required=${this.required} placeholder=${this.placeholder} aria-labelledby=${l(this.getLabelledBy())} aria-invalid=${this.invalid ? "true" : "false"} @change=${this.handleChange} @focus=${this.handleFocus} @blur=${this.handleBlur} autocomplete=${l(this.autocomplete)} >${this.renderOptionElements()}</select></div><div class="select__native-slot"><slot @slotchange=${this.handleNativeSlotChanged}></slot></div>${this.renderClearable(hasSelection)} ${this.renderSelectIcon()}<span part="suffix" class="form-control__control--suffix"><slot name="suffix"></slot></span>`;
  }
  renderMenuControl(hasSelection) {
    var _a;
    requestAnimationFrame(() => {
      this.base.classList.remove("select--native");
    });
    return $`<fadv-dropdown part="base" .hoist=${this.hoist} .stayOpenOnSelect=${this.multiple} .containingElement=${this} ?disabled=${this.disabled} class=${o({
      select: true,
      "select--open": this.isOpen,
      "select--empty": ((_a = this.value) == null ? void 0 : _a.length) === 0,
      "select--clearable": this.clearable,
      "select--disabled": this.disabled,
      "select--multiple": this.multiple,
      "select--has-tags": this.multiple && this.displayTags.length > 0,
      "select--placeholder-visible": this.displayLabel === ""
    })} @sl-show=${this.handleMenuShow} @sl-hide=${this.handleMenuHide} distance="1" ><div part="control" slot="trigger" id=${this.inputId} class="select__control" role="combobox" aria-labelledby=${l(this.getLabelledBy())} aria-haspopup="true" aria-expanded=${this.isOpen ? "true" : "false"} tabindex=${this.disabled ? "-1" : "0"} @blur=${this.handleBlur} @focus=${this.handleFocus} @keydown=${this.handleKeyDown} ><span part="prefix" class="form-control__control--prefix"><slot name="prefix"></slot></span><div class="form-control__control-host">${this.renderFloatingLabel()}<div class="form-control__control">${this.renderDisplayTags()}</div>${this.renderClearable(hasSelection)}</div><span part="suffix" class="form-control__control--suffix"><slot name="suffix"></slot></span>${this.renderSelectIcon()}<input class="select__hidden-select" aria-hidden="true" ?required=${this.required} .value=${hasSelection ? "1" : ""} tabindex="-1" /></div><fadv-menu part="menu" .scrollable=${l(this.scrollable)} class=${o({
      select__menu: true,
      "select__scroll-menu": this.hasSlotController.test("search") || this.scrollable
    })} @sl-select=${this.handleMenuSelect} >${this.renderSearch()}<slot @slotchange=${this.handleMenuSlotChange}></slot></fadv-menu></fadv-dropdown>`;
  }
  renderControl() {
    var _a;
    const hasSelection = this.multiple ? ((_a = this.value) == null ? void 0 : _a.length) > 0 : this.value !== "";
    return this.renderMenuControl(hasSelection);
  }
};
FadvSelect.styles = [...FormControl.styles, select_styles_default];
__decorateClass([
  i(".form-control")
], FadvSelect.prototype, "base", 2);
__decorateClass([
  i(".select__control")
], FadvSelect.prototype, "control", 2);
__decorateClass([
  i(".select")
], FadvSelect.prototype, "dropdown", 2);
__decorateClass([
  i(".select__menu")
], FadvSelect.prototype, "menu", 2);
__decorateClass([
  i(".select__hidden-select")
], FadvSelect.prototype, "input", 2);
__decorateClass([
  i("select.form-control__control")
], FadvSelect.prototype, "select", 2);
__decorateClass([
  t()
], FadvSelect.prototype, "isOpen", 2);
__decorateClass([
  t()
], FadvSelect.prototype, "displayLabel", 2);
__decorateClass([
  t()
], FadvSelect.prototype, "displayTags", 2);
__decorateClass([
  t()
], FadvSelect.prototype, "isNative", 2);
__decorateClass([
  t()
], FadvSelect.prototype, "optionCount", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvSelect.prototype, "multiple", 2);
__decorateClass([
  e({ attribute: "max-tags-visible", type: Number })
], FadvSelect.prototype, "maxTagsVisible", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvSelect.prototype, "disabled", 2);
__decorateClass([
  e({ type: Boolean })
], FadvSelect.prototype, "hoist", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvSelect.prototype, "required", 2);
__decorateClass([
  e({ type: Boolean })
], FadvSelect.prototype, "clearable", 2);
__decorateClass([
  e()
], FadvSelect.prototype, "value", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvSelect.prototype, "scrollable", 2);
__decorateClass([
  e({ type: Number, reflect: true })
], FadvSelect.prototype, "size", 2);
__decorateClass([
  e({ type: Boolean, reflect: true, attribute: "native" })
], FadvSelect.prototype, "native", 2);
__decorateClass([
  e()
], FadvSelect.prototype, "breakpoint", 2);
__decorateClass([
  e()
], FadvSelect.prototype, "autocomplete", 2);
__decorateClass([
  watch("disabled")
], FadvSelect.prototype, "handleDisabledChange", 1);
__decorateClass([
  watch("multiple")
], FadvSelect.prototype, "handleMultipleChange", 1);
FadvSelect = __decorateClass([
  n("fadv-select")
], FadvSelect);

export {
  FadvSelect
};
